// src/utils/apiService.js
import SummaryApi from '../common/index'; // optional – can be used directly too

const getHeaders = () => ({
  'Content-Type': 'application/json',
  // Add auth when needed:
  // 'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
});

export const apiCall = async (apiConfig, body = null, customUrl = null) => {
  const url = customUrl || apiConfig.url;
  const method = apiConfig.method || 'GET';

  const options = {
    method,
    headers: getHeaders(),
  };

  if (body && (method === 'POST' || method === 'PUT')) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      let errorMessage = `HTTP ${response.status}`;
      try {
        const errorData = await response.json();
        errorMessage += ` - ${errorData.message || errorData.error || 'Unknown error'}`;
      } catch {}
      throw new Error(errorMessage);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`API call failed: ${url}`, error);
    throw error;
  }
};

// Convenience wrappers (optional but cleaner)
export const getAppointments = () => apiCall(SummaryApi.getAllAppointments);
export const createAppointment = (data) => apiCall(SummaryApi.createAppointment, data);